// extracted by mini-css-extract-plugin
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var linkTile = "styles-module--linkTile--U-lKU";
export var linkTiles = "styles-module--linkTiles--lUOWA";
export var loadMoreButton = "styles-module--loadMoreButton--H7T4A";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";